export default "__VITE_ASSET__C6oqh6EQ__"